import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Toolbar, useMediaQuery } from "@mui/material";
import { drawerWidth, backgroundColor } from "../../config";
import SidebarWrapper from "./sidebar/SidebarWrapper";
import SuiteNavHeader from "./header/SuiteNavHeader";
import Footer from "./footer/Footer";

function RootLayout({ sidebar }) {
    return (
        <Box
            sx={{
                display: "flex",
                width: "100%",
                height: "100vh",
                backgroundColor: backgroundColor,
            }}
        >
            {/** Header */}
            <SuiteNavHeader />
            {/** Sidebar */}
            <SidebarWrapper sidebar={sidebar} />
            {/** Core */}
            <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
                <Toolbar variant="dense" />
                <Outlet />
                <Footer />
            </Box>
        </Box>
    );
}

export default RootLayout;
